export const isValidURL = (str: string) => {
  const pattern = /^(https?:\/\/)?([\w\-]+\.)+[\w\-]+(\/[\w\-./?%&=]*)?$/i;
  return pattern.test(str);
};

export const preventCachedImage = (image: string) => {
  if (!image) return "";
  else if (isValidURL(image)) return `${image}?t=${Date.now()}`;
  else return image;
};

export const getStatusStyle = (status: string) => {
  switch (status.toLowerCase()) {
    case "ongoing":
      return "text-[#B54708] bg-[#FFFAEB] border-[#FEDF89]";
    case "open":
      return "text-[#1672EC] bg-[#F0F9FF] border-[#B9E6FE]";
    case "draft":
      return "text-[#344054] bg-[#F9FAFB] border-[#EAECF0]";
    case "completed":
      return "text-[#067647] bg-[#ECFDF3] border-[#ABEFC6]";
    case "cancelled":
      return "text-[#B42318] bg-[#FEF3F2] border-[#FECDCA]";
    default:
      return "text-[#344054] bg-[#F9FAFB] border-[#D0D5DD]";
  }
};
